import { Observable } from "rxjs";

import { HttpResponse } from "@angular/common/http";

export abstract class VfiscalGateway {
    abstract reporte(): Observable<HttpResponse<Blob>>;
}